import { addBoxProduct } from '@/redux/slices/box.slice';
import { redirectBoxPage } from '@/redux/slices/product.slice';
import { addItemToStorageWB } from '@/redux/slices/storage.slice';
import { addToast } from '@/redux/slices/toast.slice';
import { WINEBOX_MAX } from '@/constants/cart';

export const getQuantityAvailable = (boxItems, itemCP, nbBoxItem) => {
  let size = itemCP.stock;
  size -= boxItems?.find((item) => item.product.item.partnumber === itemCP.partnumber)?.quantity ?? 0;
  const availableSize = WINEBOX_MAX - (nbBoxItem ?? 0);
  size = Math.max(Math.min(availableSize, size), 0);

  return size;
};

export const getQuantityAvailableForStorageWB = (storageWBProducts, storageItem, nbBoxItem) => {
  let size = storageItem.quantity;
  size -= storageWBProducts?.find(
    ({ storageItemsForCart }) => storageItemsForCart?.[0].itemId === storageItem.itemId)?.quantity ?? 0;
  const availableSize = WINEBOX_MAX - (nbBoxItem ?? 0);
  size = Math.max(Math.min(availableSize, size), 0);

  return size;
};

export const getSizeStock = (boxItems, itemCP) => {
  let size = itemCP.stock;
  size -= boxItems?.find((item) => item.product.item.partnumber === itemCP.partnumber)?.quantity ?? 0;
  size = Math.max(size, 0);

  return size;
};

export const getQuantityToAdd = (boxItems, partnumber, quantityToAdd) => {
  const boxItem = boxItems?.find((item) => item.product.item.partnumber === partnumber);
  if (boxItem) {
    quantityToAdd = boxItem.quantity + quantityToAdd;
  }
  return quantityToAdd;
};

export const isCardDisable = (storage, isWineBoxStorageComplete, nbItem, wineboxModalOpen) => {
  if (storage) {
    return isWineBoxStorageComplete && !wineboxModalOpen;
  } else {
    return nbItem === WINEBOX_MAX && !wineboxModalOpen;
  }
};

export const getLinkWineBoxPush = (productList, url, dispatch, t) => {
  const link = `${url}?wineBoxPush=`;
  const productStrings = productList.map((p) => `${p.product.item.partnumber}:${p.quantity}`);

  navigator.clipboard.writeText(link + productStrings.join('|')).then(() => {
    dispatch(addToast({ msg: t('winebox.copyLinkSuccess'), err: false }));
  }).catch(() => {
    dispatch(addToast({ msg: t('winebox.copyLinkError') }));
  });
};

export const getItemListToAdd = (wineBoxPush) => {
  const itemQuantities = wineBoxPush.split('|').reduce((obj, item) => {
    const [partnumber, qty] = item.split(':');
    obj[partnumber] = (obj[partnumber] || 0) + parseInt(qty);
    return obj;
  }, {});

  return Object.entries(itemQuantities).map(([partnumber, qty]) => ({
    partnumber,
    qty
  }));
};

export const computeDataFromStorage = (itemList) => {
  const computedArray = [];

  itemList.forEach((product) => {
    const { storageItemsForCart } = product;
    const { quantity } = storageItemsForCart[0];

    for (let i = 0; i < quantity; i++) {
      computedArray.push({ ...product });
    }
  });

  return computedArray;
};

export const getStorageItemQuantityToAddOrRemove = (storageWineBox, product, isRemove, quantity = 0) => {
  const item = storageWineBox?.map(
    ({ storageItemsForCart }) => storageItemsForCart
  ).find(
    ([{ itemId }]) => itemId === product.itemId
  );

  if (isRemove) {
    return item?.[0].quantity - 1;
  }

  if (storageWineBox.length < 1 || !item) {
    return quantity;
  }

  return quantity + item[0].quantity;
};

export const getItemsList = (boxType, box) => {
  const getBox = {
    storageBox: () => {
      const groupedItems = {};

      box.products.forEach((product) => {
        const { productName, shortDesc, storageItemsForCart } = product;
        const { itemId, shortDesc: itemShortDesc, quantity, image, attributes } = storageItemsForCart[0];

        return groupedItems[itemId] ? (
          groupedItems[itemId].storageItemsForCart[0].quantity += quantity
        ) : (
          groupedItems[itemId] = {
            productName,
            shortDesc,
            image,
            attributes,
            storageItemsForCart: [{ itemId, shortDesc: itemShortDesc, quantity }],
          }
        );
      });

      return Object.values(groupedItems);
    },
    box: () => {
      const temp = [];
      box.products?.map((product) => {
        for (let i = 0; i < product.quantity; i++) {
          temp.push(product);
        }
      });
      return temp;
    }
  };
  return getBox[boxType]?.();
};

export const computeDataByStorageOrNot = (storage, box, storageWineBox, storageForWB, products, currentItem, dispatch) => {
  let haveItemWBQuantityAvailable;
  let isWBFull;
  let deleteItemAction;
  let duplicateItemAction;

  if (storage) {
    const itemQuantity = products.length > 0 && Object.keys(storageForWB)?.filter(
      (itemId) => storageForWB?.[itemId] !== null
    ).map(
      (itemId) => storageForWB?.[itemId]
    ).find(
      ({ storageItem }) => storageItem?.itemId === currentItem.itemId
    )?.storageItem?.quantity;

    const findProductsInWineBox = products?.find(
      ({ storageItemsForCart }) => storageItemsForCart?.[0].itemId === currentItem?.itemId
    );

    haveItemWBQuantityAvailable = findProductsInWineBox?.storageItemsForCart?.[0].quantity === itemQuantity;

    isWBFull = storageWineBox.isComplete;

    const qty = getStorageItemQuantityToAddOrRemove(products, currentItem, true);

    deleteItemAction = () => (
      dispatch(addItemToStorageWB({
        itemId: currentItem.itemId,
        quantity: qty
      }))
    );

    duplicateItemAction = () => (
      dispatch(addItemToStorageWB({
        itemId: currentItem.itemId,
        quantity: findProductsInWineBox?.storageItemsForCart?.[0].quantity + 1
      }))
    );
  } else {
    const findProductsInWineBox = box.products?.find(
      ({ product }) => product.item.partnumber === currentItem?.partnumber
    );

    haveItemWBQuantityAvailable = box.products.length > 0 &&
      findProductsInWineBox?.product?.item.stock === findProductsInWineBox?.quantity;

    isWBFull = box.nbItem === WINEBOX_MAX;

    deleteItemAction = () => (
      dispatch(addBoxProduct({
        item: findProductsInWineBox.product.item.partnumber,
        qty: findProductsInWineBox.quantity - 1,
        options: {
          set: true
        }
      }))
    );

    duplicateItemAction = () => (
      dispatch(addBoxProduct({
        item: findProductsInWineBox.product.item.partnumber,
        qty: findProductsInWineBox.quantity + 1,
        options: {
          set: true,
          showConfirm: false
        }
      }))
    );
  }

  return { haveItemWBQuantityAvailable, isWBFull, deleteItemAction, duplicateItemAction };
};

export const redirectToBoxPageAndAddItem = (dispatch, item, boxItems, millesime, qty) => {
  dispatch(redirectBoxPage({
    inStockId: item.attributes.in_stock.valueId,
    item: item.partnumber,
    millesime: millesime?.valueId,
    qty: getQuantityToAdd(boxItems, item.partnumber, qty),
    options: {
      setQty: true,
      showConfirm: false
    }
  }));
};
